var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_2509)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4C0 4.65624 4.65624 0 10.4 0H37.6C43.3438 0 48 4.65624 48 10.4V37.6C48 43.3438 43.3438 48 37.6 48H10.4C4.65624 48 0 43.3438 0 37.6V10.4Z",
    fill: "#F95353"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4C0 4.65624 4.65624 0 10.4 0H37.6C43.3438 0 48 4.65624 48 10.4V37.6C48 43.3438 43.3438 48 37.6 48H10.4C4.65624 48 0 43.3438 0 37.6V10.4Z",
    fill: "url(#paint0_linear_164_2509)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4C0 4.65624 4.65624 0 10.4 0H37.6C43.3438 0 48 4.65624 48 10.4V37.6C48 43.3438 43.3438 48 37.6 48H10.4C4.65624 48 0 43.3438 0 37.6V10.4Z",
    fill: "url(#paint1_linear_164_2509)",
    fillOpacity: 0.3,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 9.15527e-05C18.1333 0.133425 22.56 1.52009 26.4 6.00009C30.24 10.4801 39.7333 19.6001 44 23.6001C45.3325 24.9326 47.9967 28.5556 48 32.393C48 32.3953 48 32.3977 48 32.4001L48 37.6C48 43.3438 43.3438 48 37.6 48H10.4C4.65624 48 0 43.3438 0 37.6V10.4C0 4.65624 4.65624 0 10.4 0H16.3113C16.3407 6.09958e-05 16.3703 9.15527e-05 16.4 9.15527e-05Z",
    fill: "url(#paint2_linear_164_2509)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3681 14.3999C15.7291 14.3999 14.4004 15.7286 14.4004 17.3676V19.1483C14.4004 20.7873 15.7291 22.116 17.3681 22.116H19.1488C20.7878 22.116 22.1165 20.7873 22.1165 19.1483V17.3676C22.1165 15.7286 20.7878 14.3999 19.1488 14.3999H17.3681ZM16.7746 17.3676C16.7746 17.0398 17.0403 16.7741 17.3681 16.7741H19.1488C19.4766 16.7741 19.7423 17.0398 19.7423 17.3676V19.1483C19.7423 19.4761 19.4766 19.7418 19.1488 19.7418H17.3681C17.0403 19.7418 16.7746 19.4761 16.7746 19.1483V17.3676Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3681 25.0838C15.7291 25.0838 14.4004 26.4125 14.4004 28.0515V29.8322C14.4004 31.4712 15.7291 32.7999 17.3681 32.7999H19.1488C20.7878 32.7999 22.1165 31.4712 22.1165 29.8322V28.0515C22.1165 26.4125 20.7878 25.0838 19.1488 25.0838H17.3681ZM16.7746 28.0515C16.7746 27.7237 17.0403 27.458 17.3681 27.458H19.1488C19.4766 27.458 19.7423 27.7237 19.7423 28.0515V29.8322C19.7423 30.16 19.4766 30.4257 19.1488 30.4257H17.3681C17.0403 30.4257 16.7746 30.16 16.7746 29.8322V28.0515Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0843 17.3676C25.0843 15.7286 26.413 14.3999 28.052 14.3999H29.8326C31.4717 14.3999 32.8004 15.7286 32.8004 17.3676V19.1483C32.8004 20.7873 31.4717 22.116 29.8326 22.116H28.052C26.413 22.116 25.0843 20.7873 25.0843 19.1483V17.3676ZM28.052 16.7741C27.7242 16.7741 27.4585 17.0398 27.4585 17.3676V19.1483C27.4585 19.4761 27.7242 19.7418 28.052 19.7418H29.8326C30.1605 19.7418 30.4262 19.4761 30.4262 19.1483V17.3676C30.4262 17.0398 30.1605 16.7741 29.8326 16.7741H28.052Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9746 25.0838C25.4829 25.0838 25.0843 25.4824 25.0843 25.9741V27.1612C25.0843 27.6529 25.4829 28.0515 25.9746 28.0515H27.1617C27.6534 28.0515 28.052 27.6529 28.052 27.1612V25.9741C28.052 25.4824 27.6534 25.0838 27.1617 25.0838H25.9746Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8326 25.9741C29.8326 25.4824 30.2313 25.0838 30.723 25.0838H31.9101C32.4018 25.0838 32.8004 25.4824 32.8004 25.9741V28.9418C32.8004 29.4335 32.4018 29.8322 31.9101 29.8322H30.723C30.2313 29.8322 29.8326 29.4335 29.8326 28.9418V25.9741Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9746 29.8322C25.4829 29.8322 25.0843 30.2308 25.0843 30.7225V31.9096C25.0843 32.4013 25.4829 32.7999 25.9746 32.7999H28.9423C29.434 32.7999 29.8326 32.4013 29.8326 31.9096V30.7225C29.8326 30.2308 29.434 29.8322 28.9423 29.8322H25.9746Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 9.15527e-05C18.1333 0.133425 22.56 1.52009 26.4 6.00009C30.24 10.4801 39.7333 19.6001 44 23.6001C45.3325 24.9326 47.9967 28.5556 48 32.393C48 32.3953 48 32.3977 48 32.4001L48 37.6C48 43.3438 43.3438 48 37.6 48H10.4C4.65624 48 0 43.3438 0 37.6V10.4C0 4.65624 4.65624 0 10.4 0H16.3113C16.3407 6.09958e-05 16.3703 9.15527e-05 16.4 9.15527e-05Z",
    fill: "url(#paint3_linear_164_2509)",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8302 16.0214C27.6416 13.3088 27.2427 9.96192 26.3995 6.80019C25.9469 5.10309 25.0059 4.61572 24.7559 4.2876C25.8027 5.2751 25.8996 5.3876 27.1995 6.80019L42.7995 22.4001C43.1437 22.7443 43.4218 23.035 43.6965 23.3095C42.9388 22.6712 42.039 22.2067 40.7995 22.0001C38.3761 21.5962 35.5789 21.3622 33.1799 21.2467C30.3871 21.1122 28.0243 18.8107 27.8302 16.0214Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8302 16.0214C27.6416 13.3088 27.2427 9.96192 26.3995 6.80019C25.9469 5.10309 25.0059 4.61572 24.7559 4.2876C25.8027 5.2751 25.8996 5.3876 27.1995 6.80019L42.7995 22.4001C43.1437 22.7443 43.4218 23.035 43.6965 23.3095C42.9388 22.6712 42.039 22.2067 40.7995 22.0001C38.3761 21.5962 35.5789 21.3622 33.1799 21.2467C30.3871 21.1122 28.0243 18.8107 27.8302 16.0214Z",
    fill: "url(#paint4_linear_164_2509)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_2509",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 31.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_2509",
    x1: 48,
    y1: 0,
    x2: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30625
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_164_2509",
    x1: 24,
    y1: -8.8,
    x2: 24,
    y2: 53.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_164_2509",
    x1: 34.4,
    y1: 14,
    x2: 3.6,
    y2: 45.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00196D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400982,
    stopColor: "#365EE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_164_2509",
    x1: 34.7996,
    y1: 14.4001,
    x2: 29.1996,
    y2: 19.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F41B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#466BE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_2509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.1e7d8617f238f067e3a446c003c0d6c6.svg";
export { ForwardRef as ReactComponent };